import Select from "react-select";
import React, { useEffect, useState } from "react";
import Layout from "../Component/Layout";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useNavigate } from "react-router-dom"; // add at top


 
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
} from "chart.js";


import { Bar, Line, Pie } from "react-chartjs-2";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement
);


const styles = {
  pageTitleBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 16,
  },
  pageTitle: {
    fontSize: 20,
    fontWeight: 600,
    color: "#1e293b",
  },
  pageSubtitle: {
    fontSize: 12,
    color: "#64748b",
  },
  filterCard: {
    background: "#ffffff",
    borderRadius: 8,
    padding: 20,
    boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
    marginBottom: 18,
  },
  filterLabel: {
    fontSize: 13,
    fontWeight: 600,
    marginBottom: 6,
    color: "#334155",
  },
  card: {
    background: "#fff",
    borderRadius: 8,
    padding: 16,
    boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
    textAlign: "center",
  },
};


const thStyle = {
  padding: "12px 14px",
  textAlign: "left",
};


const tdStyle = {
  padding: "14px 14px",
  //fontSize: "13px",
  color: "#334155",
  verticalAlign: "middle",
};


const selectStyles = {
  control: (base) => ({
    ...base,
    minHeight: "38px",
    borderRadius: "8px",
    fontSize: "13px",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 6px",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: "32px",
  }),
};


const OrderDashboard = () => {
  const [summary, setSummary] = useState({});


  const [filters, setFilters] = useState({
    year: "",
    month: "",
    fromDate: "",
    toDate: "",
    division: "",
    customer: "",
    workCentre: "",
    productGroup: "",
    productCode: "",
    status: "",
  });


  const exportToExcel = async () => {
  try {
    const res = await axios.get(
      "https://master.erp.sbeecables.com/api/productiondashboard/export-pod"
    );


    const data = res.data || [];


    if (data.length === 0) {
      alert("No data found in POD table");
      return;
    }


    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();


    XLSX.utils.book_append_sheet(workbook, worksheet, "POD Data");


    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });


    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });


    saveAs(blob, "Full_POD_Table.xlsx");


  } catch (err) {
    console.error("Export failed", err);
  }
};


const [view, setView] = useState("table");


const graphData = {
  labels: ["Planning", "Released", "Confirmed", "Rework", "Quality"],
  datasets: [
    {
      label: "Orders",
      data: [
        summary.inPlanning || 0,
        summary.released || 0,
        summary.confirmed || 0,
        summary.rework || 0,
        summary.inQuality || 0,
      ],


      barThickness: 18,        // ✅ controls width
      maxBarThickness: 20,     // ✅ safety cap
      categoryPercentage: 0.6, // ✅ spacing between groups
      barPercentage: 0.6,  
     
      backgroundColor: [
        "#3b82f6",
        "#22c55e",
        "#0ea5e9",
        "#f97316",
        "#eab308",
      ],
      borderColor: "#6366f1",
      fill: view === "area" ? true : false,
      backgroundColor: view === "area"
        ? "rgba(99,102,241,0.2)"   // 🔥 shaded area
        : [
            "#3b82f6",
            "#22c55e",
            "#0ea5e9",
            "#f97316",
            "#eab308",
          ],
      tension: 0.4,
    },
  ],
};


const graphOptions = {
  responsive: true,
  maintainAspectRatio: false,
  elements: {
  line: {
    tension: 0.4,
    borderWidth: 2,
  }
  },
  interaction: {
  mode: "index",
  intersect: false,
  },
  plugins: {
    legend: { display: false },
  },
  scales: {
    x: {
      ticks: { font: { size: 11 } },
      grid: { display: false },
    },
    y: {
      beginAtZero: true,
      ticks: {
        stepSize: 5,
        font: { size: 11 },
      },
    },
  },
};


  // ALL DROPDOWN STATES
  const [customerOptions, setCustomerOptions] = useState([]);
  const [divisionOptions, setDivisionOptions] = useState([]);
  const [workCentreOptions, setWorkCentreOptions] = useState([]);
  const [productGroupOptions, setProductGroupOptions] = useState([]);
  const [productCodeOptions, setProductCodeOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState([]);
  const [tableData, setTableData] = useState([]);
  //const [graphType, setGraphType] = useState("bar");
  const [graphDropdown, setGraphDropdown] = useState(false);
  const navigate = useNavigate();


  const handleChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };


  // FETCH DATA
  const fetchData = async () => {
    try {


      // TABLE
      const orderRes = await axios.get(
        "https://master.erp.sbeecables.com/api/productiondashboard/orders",
        { params: filters }
      );


      // TILES
      const tileRes = await axios.get(
        "https://master.erp.sbeecables.com/api/productiondashboard/tiles",
        { params: filters }
      );


      if (orderRes.data.success) {
        setTableData(orderRes.data.data || []);
      }


      if (tileRes.data.success) {
        setSummary(tileRes.data.data || {});
      }


    } catch (err) {
      console.error("Dashboard error", err);
    }
  };


  // FETCH DROPDOWNS
  const fetchDropdowns = async () => {
  try {
    const [
      custRes,
      divRes,
      wcRes,
      pgRes,
      pcRes,
      stRes,
      yearRes,
      monthRes
    ] = await Promise.all([
      axios.get("https://master.erp.sbeecables.com/api/productiondashboard/customers"),
      axios.get("https://master.erp.sbeecables.com/api/productiondashboard/divisions"),
      axios.get("https://master.erp.sbeecables.com/api/productiondashboard/workcentres"),
      axios.get("https://master.erp.sbeecables.com/api/productiondashboard/product-groups"),
      axios.get("https://master.erp.sbeecables.com/api/productiondashboard/product-codes"),
      axios.get("https://master.erp.sbeecables.com/api/productiondashboard/statuses"),
      axios.get("https://master.erp.sbeecables.com/api/productiondashboard/years"),
      axios.get("https://master.erp.sbeecables.com/api/productiondashboard/months"),
    ]);


    // ✅ CUSTOMER
    setCustomerOptions(
      (custRes.data || []).map(item => ({
        label: item.customer,
        value: item.customer
      }))
    );


    // ✅ DIVISION
    setDivisionOptions(
      (divRes.data || []).map(item => ({
        label: item.division,
        value: item.division
      }))
    );


    // ✅ WORK CENTRE
    setWorkCentreOptions(
      (wcRes.data || []).map(item => ({
        label: item.workcenter_name,
        value: item.workcenter_name
      }))
    );


    // ✅ PRODUCT GROUP
    setProductGroupOptions(
      (pgRes.data || []).map(item => ({
        label: item.productGroup,
        value: item.productGroup
      }))
    );


    // ✅ PRODUCT CODE
    setProductCodeOptions(
      (pcRes.data || []).map(item => ({
        label: item.header_product_code,
        value: item.header_product_code
      }))
    );


    // ✅ STATUS
    setStatusOptions(
      (stRes.data || []).map(item => ({
        label: item.status,
        value: item.status
      }))
    );


    // ✅ YEAR
    setYearOptions(
      (yearRes.data || []).map(y => ({
        label: y.year,
        value: y.year
      }))
    );


    // ✅ MONTH
    setMonthOptions(
      (monthRes.data || []).map(m => ({
        label: m.month,
        value: m.month
      }))
    );


  } catch (err) {
    console.error("Dropdown error", err);
  }
};


  // DEBOUNCE API CALL
  useEffect(() => {
    const delay = setTimeout(() => {
      fetchData();
    }, 300);


    return () => clearTimeout(delay);
  }, [filters]);


  useEffect(() => {
    fetchDropdowns();
  }, []);


  const cards = [
    { title: "Total", key: "total", color: "#6366f1" },
  { title: "In Planning", key: "inPlanning", color: "#3b82f6" },
 
  { title: "Released", key: "released", color: "#22c55e" },
  { title: "Confirmed", key: "confirmed", color: "#0ea5e9" },
  { title: "In Quality", key: "inQuality", color: "#eab308" },
  { title: "Rework", key: "rework", color: "#f97316" },
];


const uniqueTableData = Object.values(
  (tableData || []).reduce((acc, item) => {
    const key = item.planned_order_no || item.production_order_number;


    if (key && !acc[key]) {
      acc[key] = item;
    }


    return acc;
  }, {})
);


  return (
    <Layout>
      <div className="container-fluid p-4">
      {/* HEADER */}
      <div style={{ marginBottom: "10px" }}>
  <h3 className="fw-bold">Production Order Dashboard</h3>
  <p className="text-muted mb-0">Production tracking & status overview</p>
</div>
      {/* FILTERS */}
      <div className="bg-light p-3 rounded-4 border border-2">


        {/* ROW 1 */}
        <div className="row g-4 mb-2">


          <div className="col-md-2">
            <label style={styles.filterLabel}>Year</label>
            <Select
              options={yearOptions}
              value={yearOptions.find(y => y.value === filters.year) || null}
              onChange={(s) => handleChange("year", s ? s.value : "")}
              isClearable
            />
          </div>


          <div className="col-md-2">
            <label style={styles.filterLabel}>Month</label>
            <Select
              options={monthOptions}
              value={monthOptions.find(m => m.value === filters.month) || null}
              onChange={(s) => handleChange("month", s ? s.value : "")}
              isClearable
            />
          </div>


          <div className="col-md-2">
            <label style={styles.filterLabel}>From</label>
            <input
              type="date"
              className="form-control form-control-sm"
              value={filters.fromDate}
              onChange={(e) => handleChange("fromDate", e.target.value)}
            />
          </div>


          <div className="col-md-2">
            <label style={styles.filterLabel}>To</label>
            <input
              type="date"
              className="form-control form-control-sm"
              value={filters.toDate}
              onChange={(e) => handleChange("toDate", e.target.value)}
            />
          </div>


        </div>


        {/* ROW 2 */}
        <div className="row g-4">


          <div className="col-md-2">
            <label style={styles.filterLabel}>Division</label>
            <Select
              options={divisionOptions}
              value={divisionOptions.find(d => d.value === filters.division) || null}
              onChange={(s) => handleChange("division", s ? s.value : "")}
              isClearable
              styles={selectStyles}
              menuPortalTarget={document.body}
              menuPosition="fixed"
            />
          </div>


          <div className="col-md-2">
            <label style={styles.filterLabel}>Customer</label>
            <Select
              options={customerOptions}
              value={customerOptions.find(c => c.value === filters.customer) || null}
              onChange={(s) => handleChange("customer", s ? s.value : "")}
              isClearable
              styles={selectStyles}
              menuPortalTarget={document.body}
              menuPosition="fixed"
            />
          </div>


          <div className="col-md-2">
            <label style={styles.filterLabel}>Work Centre</label>
            <Select
              options={workCentreOptions}
              value={workCentreOptions.find(w => w.value === filters.workCentre) || null}
              onChange={(s) => handleChange("workCentre", s ? s.value : "")}
              isClearable
              styles={selectStyles}
              menuPortalTarget={document.body}
              menuPosition="fixed"
            />
          </div>


          <div className="col-md-2">
            <label style={styles.filterLabel}>Product Group</label>
            <Select
              options={productGroupOptions}
              value={productGroupOptions.find(p => p.value === filters.productGroup) || null}
              onChange={(s) => handleChange("productGroup", s ? s.value : "")}
              isClearable
              styles={selectStyles}
              menuPortalTarget={document.body}
              menuPosition="fixed"
            />
          </div>


          <div className="col-md-2">
            <label style={styles.filterLabel}>Product Code</label>
            <Select
              options={productCodeOptions}
              value={productCodeOptions.find(p => p.value === filters.productCode) || null}
              onChange={(s) => handleChange("productCode", s ? s.value : "")}
              isClearable
              styles={selectStyles}
              menuPortalTarget={document.body}
              menuPosition="fixed"
            />
          </div>


          <div className="col-md-2">
            <label style={styles.filterLabel}>Status</label>
            <Select
              options={statusOptions}
              value={statusOptions.find(s => s.value === filters.status) || null}
              onChange={(s) => handleChange("status", s ? s.value : "")}
              isClearable
              styles={selectStyles}
              menuPortalTarget={document.body}
              menuPosition="fixed"
            />
          </div>


        </div>


      </div>


      {/* CARDS */}
      <div className="row mt-3">
      {cards.map((c, i) => (
        <div className="col-md-2 mb-3" key={i}>
          <div
            style={
              {
  background: "#f3f4f6",
  borderRadius: "12px",
  padding: "8px",
  boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
  borderLeft: `5px solid ${c.color}`,
  textAlign: "left"
}
            }
          >
            <div style={{ fontSize: 13, color: "#64748b" }}>{c.title}</div>
            <div style={{ fontSize: 22, fontWeight: 700 }}>
              {summary[c.key] || 0}
            </div>
          </div>
        </div>
      ))}
    </div>


      {/* VIEW + EXPORT */}
      <div className="d-flex justify-content-between align-items-center mt-4 mb-2">


        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ display: "flex", gap: 6 }}>


  {/* TABLE BUTTON */}
  <button
    className="btn btn-sm"
style={{
  background: view === "table" ? "#0047AB" : "transparent",
  color: view === "table" ? "#fff" : "#0047AB",
  border: "1px solid #0047AB",fontSize: 12,
    padding: "4px 10px"
}}
    onClick={() => setView("table")}
  >
    Table
  </button>


  {/* GRAPH DROPDOWN */}
  <div style={{ position: "relative" }}>
    <button
      className="btn btn-sm"
style={{
  background: view !== "table" ? "#0047AB" : "transparent",
  color: view !== "table" ? "#fff" : "#0047AB",
  border: "1px solid #0047AB",
  fontSize: 12,
  padding: "4px 10px"
}}
      onClick={() => setGraphDropdown(prev => !prev)}    >
      Graph
    </button>


    {graphDropdown && (
      <div
        style={{
  position: "absolute",
  top: "34px",
  left: 0,
  background: "#fff",
  border: "1px solid #e2e8f0",
  borderRadius: "10px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  zIndex: 9999,
  width: 150
}}
      >
        {["bar", "line", "pie", "area"].map(type => (
          <div
            key={type}
            style={{ padding: "6px 10px", fontSize: 12, cursor: "pointer" }}
            onClick={() => {
              setView(type);
              setGraphDropdown(false);
            }}
          >
            {type.charAt(0).toUpperCase() + type.slice(1)} Chart
          </div>
        ))}
      </div>
    )}
  </div>
</div>
        </div>


        <button className="btn btn-sm"
style={{
  background:"#0047AB",
  color:"#fff",
  border:"1px solid #0047AB"
}} onClick={exportToExcel}>
          Export
        </button>


      </div>


      {/* TABLE VIEW */}
      {view === "table" && (
              <div
        style={{
          background: "#fff",
borderRadius: "10px",
padding: "15px",
boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
          border: "1px solid #e5e7eb",
          overflow: "hidden",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
          }}
        >


          {/* HEADER */}
          <thead>
            <tr
              style={{
                background: "#f5f6fa",
                fontSize: "14px",
                fontWeight: 600,
                color: "#334155",
              }}
            >
              <th style={thStyle}>POD No</th>
              <th style={thStyle}>Product Code</th>
              <th style={thStyle}>Customer</th>
              <th style={thStyle}>Work Centre</th>
              <th style={thStyle}>Order Type</th>
              <th style={thStyle}>Division</th>
              <th style={thStyle}>Product Type</th>
            </tr>
          </thead>


          {/* BODY */}
          <tbody>
            {uniqueTableData.length > 0 ? (
              uniqueTableData.map((row, i) => (
                <tr
                  key={row.production_order_number || i}
                  style={{
                    fontSize: "13px",
                    borderBottom: "1px solid #f1f5f9",
                    transition: "background 0.15s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "#f8fafc")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "#ffffff")
                  }
                >
                  <td style={tdStyle}>
  <span
    style={{
      cursor: "pointer",
      color: "#0047AB",
      textDecoration: "none" // ❌ removes underline
    }}
    onClick={() => {
     navigate(`/production-order?pod=${row.production_order_number}`);
    }}
  >
    {row.production_order_number || "-"}
  </span>
</td>
                  <td style={tdStyle}>{row.header_product_code || "-"}</td>
                  <td style={tdStyle}>{row.customer || "-"}</td>
                  <td style={tdStyle}>{row.workcenter_name || "-"}</td>
                  <td style={tdStyle}>{row.order_type || "-"}</td>
                  <td style={tdStyle}>{row.division || "-"}</td>
                  <td style={tdStyle}>{row.productType || "-"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" style={{ textAlign: "center", padding: 16 }}>
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>


        {/* FOOTER LIKE YOUR REFERENCE */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "10px 14px",
            fontSize: "12px",
            color: "#64748b",
          }}
        >
          <div>
            Page <b>1</b> of <b>1</b> • Total {uniqueTableData.length}
          </div>


          <div style={{ display: "flex", gap: 8 }}>
            <button className="btn btn-outline-secondary btn-sm">Prev</button>
            <button className="btn btn-outline-secondary btn-sm">Next</button>
          </div>
        </div>
      </div>
      )}


      {/* GRAPH VIEW */}
      {view !== "table" && (
      <div style={{ background: "#fff", padding:20, borderRadius: "12px" , boxShadow: "0 2px 6px rgba(0,0,0,0.05)" }}>
        {view === "bar" && <Bar data={graphData} options={graphOptions} />}
        {view === "line" && <Line data={graphData} options={graphOptions} />}
        {view === "area" && <Line data={graphData} options={graphOptions} />}
        {view === "pie" && (
        <div style={{
          height: "240px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}>
          <Pie
            data={graphData}
            options={{
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  position: "top",
                  labels: { font: { size: 12 } }
                }
              }
            }}
          />
        </div>
      )}
      </div>
    )}
    </div>
    </Layout>
  );
};


export default OrderDashboard;
